module.exports = __webpack_public_path__ + "img/galeria-especie-mar3.a112f767.jpg";